<script setup lang="ts">
import { ChipFilter } from "@frontiers-vue3/public-pages";
import type { IQuickChipFilter } from "./IQuickChipFilters";

defineProps<IQuickChipFilter>();
const emit = defineEmits<{
  (e: "chipClicked", chipClickedLabel: string): void;
}>();

const filterUpdated = (filterSelected: string): void => {
  emit("chipClicked", filterSelected);
};
</script>
<template>
  <div class="QuickChipFilters">
    <span class="QuickChipFilters__Title">{{ title }}</span>
    <div class="QuickChipFilters__ChipsContainer">
      <ChipFilter
        v-for="(chipButton, index) of chipButtons"
        :key="index"
        :model-value="activeChip === chipButton.value"
        :label="chipButton.label"
        color="black"
        :disabled="chipButton.disabled"
        :readonly="chipButton.readonly"
        :size="chipsSize"
        :show-tick="showTick"
        @update:model-value="filterUpdated(chipButton.value)" />
    </div>
  </div>
</template>

<style lang="scss">
.QuickChipFilters {
  display: flex;
  gap: 8px;
  align-items: center;
  width: max-content;

  &__Title {
    @include f-14-300;
  }

  &__ChipsContainer {
    display: flex;
    gap: 4px;
  }
}
</style>
